import React, { useEffect, useState } from 'react'
import { Card, Radio, Row, Col, Button, message } from 'antd'
import CommonCombinedFilter from '../../../../../components/CommonCombinedFilter'
import { AIQualityCheckCombinedFilterItem, AIQualityCheckTaskListItem } from 'src/types/ai-quality-check'
import { getQualityCheckTaskList } from '@services/ai-quality-check'
import { useParams, useHistory } from 'react-router-dom'
import { QcTypeMap, DataType, ActionMode, TaskStatus, QcType } from '../../../quality-check-scheme-detail/constants'
import { getUrlParam } from '@library'

const StartQualityCheckTaskPage = ({ onSave, onNextStep, onBack, createId }: {onSave: (data, status?: number) => void, onNextStep: (data, status?: number) => void, onBack: (data, status?: number) => void, createId: number }) => {
  const [combinedFilterData, setCombinedFilterData] = useState<AIQualityCheckCombinedFilterItem[]>([])
  const [manualReview, setManualReview] = useState(true)
  const [savedData, setSavedData] = useState<AIQualityCheckTaskListItem>({})
  const [stepThreeData, setStepThreeData] = useState({})
  const taskId = +useParams<{ id: string }>()?.id
  const status = Number(getUrlParam('status'))
  const history = useHistory()

  const getQualityCheckTaskCreateData = async () => {
    const params = {
      taskId: taskId || createId,
    }
    const [res, err] = await getQualityCheckTaskList(params)
    if (err) {
      message.error(`获取质检任务数据失败:${err?.message}`)
      return
    }
    res?.list[0] && setSavedData(res.list[0])
    if (res?.list[0]?.dataScope) {
      const data = JSON.parse(res?.list[0]?.dataScope)
      setCombinedFilterData(data.conditions)
    }
    setManualReview(res.list[0].manualReview ?? true)
    const { planNames, createTime, updateTime, completionRate, total, ...data } = res?.list?.[0] || {}
    setStepThreeData({
      ...data,
    })
  }

  useEffect(() => {
    if (!isNaN(taskId) || createId) {
      getQualityCheckTaskCreateData()
    }
  }, [taskId, createId])

  useEffect(() => {
    setStepThreeData({
      ...savedData,
      manualReview,
    })
  }, [manualReview])

  return (
    <Card className="mt20 mb20">
      <div style={{ width: '90%', margin: '0 auto' }}>
        <Row className="mt20 mb20" style={{ width: 500 }} align="middle">
          <Col span={4}>
            <h4 style={{ fontWeight: 'bold' }}>任务名称</h4>
          </Col>
          <Col span={20}>
            <div>{savedData?.taskName}</div>
          </Col>
        </Row>
        <Row className="mt20 mb20" style={{ width: 500 }}>
          <Col span={4}>
            <h4 style={{ fontWeight: 'bold' }}>数据类型</h4>
          </Col>
          <Col span={20}>
            <div>{savedData?.dataType === DataType.call ? '电话通话' : '企微对话'}</div>
          </Col>
        </Row>
        <Row className="mt20 mb20" style={{ width: 500 }}>
          <Col span={4}>
            <h4 style={{ fontWeight: 'bold' }}>运行模式</h4>
          </Col>
          <Col span={20}>
            <div>{savedData?.taskType === ActionMode.offline ? '存量数据-异步任务' : (savedData?.runType === 0 ? '增量数据-实时数据' : '增量数据-异步任务')}</div>
          </Col>
        </Row>
        <div className="mt20 mb20">
          <h4 style={{ fontWeight: 'bold' }}>数据匹配条件</h4>
          <CommonCombinedFilter className="mt20" filterType="view" data={combinedFilterData} />
        </div>
        <Row className="mt20 mb20" style={{ width: 500 }}>
          <Col span={4}>
            <h4 style={{ fontWeight: 'bold' }}>质检方案</h4>
          </Col>
          <Col span={20}>
            <div className="mb20" style={{ display: 'flex' }}>
              <div className="mr10">
                {savedData?.planNames?.[0]}
              </div>
              {savedData?.plans?.[0]?.type && (
                <Button type="dashed" size="small" style={{ borderColor: '#1890ff', color: '#1890ff' }}>
                  #{QcTypeMap[savedData?.plans?.[0]?.type]}
                </Button>
              )}
            </div>
            <div style={{ display: 'flex' }}>
              <div className="mr10">{savedData?.planNames?.[1]}</div>
              {savedData?.planNames?.[1] && savedData?.planNames?.[1] !== '' && (
                <Button type="dashed" size="small" style={{ borderColor: '#1890ff', color: '#1890ff' }}>
                  #{QcTypeMap[QcType.scenarioTag]}
                </Button>
              )}
            </div>
          </Col>
        </Row>
        {status !== TaskStatus.RUNNING && (
          <div className="mt20 mb20">
            <h4 className="mb20" style={{ fontWeight: 'bold' }}>人工复核</h4>
            <Radio.Group onChange={(e) => setManualReview(e.target.value)} value={manualReview}>
              <Radio value>是</Radio>
              <Radio value={false}>否</Radio>
            </Radio.Group>
          </div>
        )}
        {status === TaskStatus.RUNNING && (
          <Row className="mt20 mb20" style={{ width: 500 }}>
            <Col span={4}>
              <h4 style={{ fontWeight: 'bold' }}>人工复核</h4>
            </Col>
            <Col span={20}>
              {savedData?.manualReview ? '是' : '否'}
            </Col>
          </Row>
        )}
      </div>
      <div className="mt20 mb20" style={{ display: 'flex' }}>
        {status !== TaskStatus.RUNNING && (
          <>
            <Button type="primary" ghost className="mr10" style={{ color: '#0052D9', borderColor: '#0052D9' }} onClick={() => onBack(stepThreeData, TaskStatus.STOP)}>
              上一步
            </Button>
            <Button type="primary" className="mr10" style={{ backgroundColor: '#0052D9' }} onClick={() => onNextStep(stepThreeData)}>
              启用
            </Button>
            <Button type="primary" className="task-save-btn" onClick={() => onSave(stepThreeData, TaskStatus.STOP)}>
              保存
            </Button>
          </>
        )}
        {status === TaskStatus.RUNNING && (
          <Button type="primary" style={{ backgroundColor: '#0052D9' }} onClick={() => history.push('/config/quality-check-management')}>
            返回
          </Button>
        )}
      </div>
    </Card>
  )
}

export default StartQualityCheckTaskPage
